/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetConsigneeTour } from '../../models/get-consignee-tour';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeTour$Params {
  organizationSiteKey: KeyType;
  tourKey: KeyType;
}

export function getConsigneeTour(http: HttpClient, rootUrl: string, params: GetConsigneeTour$Params, context?: HttpContext): Observable<StrictHttpResponse<GetConsigneeTour>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeTour.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetConsigneeTour>;
    })
  );
}

getConsigneeTour.PATH = '/organization-sites/{organizationSiteKey}/consignee/tours/{tourKey}';
